import React, { useEffect } from 'react';
import Modal from 'react-modal';
import { useTheme } from '../../lib/ThemeContext';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import CustomAuth from '../CustomAuth';

Modal.setAppElement('#root'); // Set this to your app's root element

interface LoginModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  onLogin?: () => void; // Optional callback for settings sync after login
}

const LoginModal = ({ isOpen, onRequestClose, onLogin }: LoginModalProps) => {
  const { isDarkMode, currentTheme } = useTheme();
  const { t } = useTranslation();
  const { user, isProcessingRedirect } = useAuth();

  useEffect(() => {
    if (user && isOpen) {
      if (onLogin) {
        onLogin();
      }
      onRequestClose();
    }
  }, [user, isOpen, onLogin, onRequestClose, isProcessingRedirect]);

  // Don't show the modal if we're processing a redirect
  const shouldShowModal = isOpen && !isProcessingRedirect;

  return (
    <Modal
      isOpen={shouldShowModal}
      onRequestClose={onRequestClose}
      contentLabel={t('auth.loginModalTitle', 'Login')}
      style={{
        overlay: {
          zIndex: 9999,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
        content: {
          position: 'fixed',
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          transform: 'translate(-50%, -50%)',
          width: '90vw',
          maxWidth: 420,
          minWidth: 260,
          maxHeight: '90vh',
          minHeight: 200,
          padding: 24,
          borderRadius: 12,
          overflow: 'auto',
          zIndex: 10000,
          background: isDarkMode ? currentTheme.paper : '#fff',
          color: isDarkMode ? currentTheme.textPrimary : '#222',
          boxShadow: '0 8px 32px rgba(0,0,0,0.25)',
          margin: 0,
        }
      }}
    >
      <CustomAuth />
      <button
        onClick={onRequestClose}
        style={{
          display: 'block',
          margin: '24px auto 0',
          padding: '8px 24px',
          borderRadius: 4,
          background: isDarkMode ? currentTheme.buttonHoverBg : '#eee',
          color: isDarkMode ? currentTheme.textPrimary : '#222',
          border: 'none',
          cursor: 'pointer'
        }}
      >
        {t('auth.close', 'Close')}
      </button>
    </Modal>
  );
};

export default LoginModal;
